import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import radio from '@/lib/radio.js'
import options from '@/lib/options.js'
import getProductJson from '@/lib/getProductJson.js'

export default component((node) => {
  const opts = options(node)
  const form = node.querySelector('form')
  //console.log(node)
  const addToCart = form.elements.add

  // cache
  getProductJson()

  
  opts.onUpdate(state => {
    getProductJson().then(json => {
      const variant = json.variants.filter(v => v.id == state.id)[0]
      //console.log("variant chosen: " + JSON.stringify(variant, null, "\t"))
      const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
        variant.inventory_quantity
      ) : null // null means they can add as many as they want

      if (numAvailable !== null && 1 > numAvailable) {
        
        /* Disable add to cart because inventory is 0*/
        addToCart.classList.add('i')
        addToCart.innerHTML = 'Sold Out!'
        addToCart.setAttribute("disabled", "disabled");
      }else{
        /* Re-enable add ot cart and text */
        addToCart.classList.remove('i')
        addToCart.innerHTML = 'Add To Cart'
        addToCart.removeAttribute("disabled");
      }

    })
  })
  
})
